import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { AuthProvider, ProtectedRoute, LoginPage } from './components/Auth';
import { MainLayout } from './components/Layout';
import { DashboardPage } from './components/Dashboard';
import { AssignmentsListPage, AssignmentForm } from './components/Assignments';
import { BusesListPage, BusForm } from './components/Buses';
import { SessionsPage } from './components/Sessions';
import { PositionsViewPage } from './components/Positions';
import { LiveMapPage } from './components/Map';
import './utils/leaflet-icons'; // Fix Leaflet marker icons
import 'leaflet/dist/leaflet.css'; // Leaflet styles

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <DashboardPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Assignments Routes */}
            <Route
              path="/assignments"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <AssignmentsListPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/assignments/new"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <AssignmentForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/assignments/:id"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <AssignmentForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Buses Routes */}
            <Route
              path="/buses"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <BusesListPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/buses/new"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <BusForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/buses/:id"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <BusForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Sessions Route */}
            <Route
              path="/sessions"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <SessionsPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Positions Route */}
            <Route
              path="/positions/:sessionId"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <MainLayout>
                    <PositionsViewPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Live Map Route */}
            <Route
              path="/map"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <LiveMapPage />
                </ProtectedRoute>
              }
            />

            {/* Catch-all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
